<template>
  <div
    v-on-clickaway="() => {isTagsExpanded = false}"
    class="flex items-center flex-nowrap gap-2 h-11 relative"
    style="width: 240px"

    @click="expandTags"
  >
    <Transition
      name="fade"
    >
      <div
        ref="tagContainer"
        :class="isTagsExpanded ? 'edit-tag-container' : 'absolute top-0 left-0 w-full h-full px-3 py-2.5 overflow-hidden'"
      >
        <LensTags
          :tags="tags"
          :is-editing="isTagsExpanded"
          :search="tagSearch"
          @addingStateChange="onAddingStateChange"
          @updateTagSearch="onUpdateTagSearch"
          @removeTag="$emit('removeTag', $event)"
        />
      </div>
    </Transition>
    <portal to="lens-tag-popover">
      <!-- Have to use conditional rendering here because the popover is not a child of the tag cell -->
      <LensTagPopover
        v-if="(isAddingTag || isCreatingTag) && tagSearch.length > 0"
        ref="tagPopoverList"
        class="fixed"
        :show="true"
        :selected-tags="tags"
        :search="tagSearch"
        :max-allowed-height="'100px'"
        :style="{ top: `${tagPopoverPosition.top}px`, left: `${tagPopoverPosition.left}px`, zIndex: 99, bottom: `${tagPopoverPosition.bottom}px` }"
        @selectTag="$emit('selectTag', $event)"
        @create-tag-start="onCreateTagStart"
        @create-tag-end="onCreateTagEnd"
      />
    </portal>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway2'
import LensTags from '../../LensTags.vue'
import LensTagPopover from '../../LensTagPopover.vue'
export default {
  name: 'TagCell',
  components: {
    LensTags,
    LensTagPopover
  },
  mixins: [clickaway],
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    isAdLevel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isTagsExpanded: false,
      isAddingTag: false,
      isCreatingTag: false,
      tagPopoverPosition: {
        top: 0,
        left: 0
      },
      tagSearch: ''
    }
  },
  methods: {
    onUpdateTagSearch (search) {
      this.tagSearch = search
      this.updateTagPopoverPosition()
    },
    expandTags () {
      if (this.tags.length > 0) {
        this.isTagsExpanded = true
      }
    },
    onAddingStateChange (isAdding) {
      if (!isAdding && !this.isCreatingTag) {
        this.tagSearch = ''
      }
      this.isAddingTag = isAdding
      this.updateTagPopoverPosition()
    },
    onCreateTagStart () {
      this.isCreatingTag = true
    },
    onCreateTagEnd () {
      this.isCreatingTag = false
      this.tagSearch = ''
    },
    updateTagPopoverPosition () {
      // Set portaled popover position (If overflow bottom of viewport, position above)
      setTimeout(() => {
        const drawerOffset = 80
        const reference = this.$refs.tagContainer
        const referenceRect = reference.getBoundingClientRect()
        // Check if popover would overflow bottom of viewport

        const tagPopoverList = this.$refs.tagPopoverList
        const popoverHeight = tagPopoverList?.$el ? tagPopoverList.$el?.firstElementChild?.getBoundingClientRect()?.height : 200
        const adLevelOffset = this.isAdLevel ? -1 * drawerOffset : 0
        const viewportHeight = window.innerHeight
        const spaceBelow = viewportHeight - referenceRect.bottom
        if (spaceBelow < popoverHeight) {
          this.tagPopoverPosition = {
            top: referenceRect.top - adLevelOffset - popoverHeight,
            left: referenceRect.left
          }
        } else {
          this.tagPopoverPosition = {
            top: referenceRect.bottom + adLevelOffset,
            left: referenceRect.left
          }
        }
      }, 0)
    }
  }
}
</script>

<style scoped>
.edit-tag-container{
  background: #FFF;
  box-shadow: 0px 24px 32px -12px rgba(53, 57, 75, 0.12), 0px 1px 2px 0px rgba(162, 172, 186, 0.08), 0px 0px 0px 1px rgba(0, 56, 108, 0.04), 0px 1px 2px 0px rgba(162, 172, 186, 0.16), 0px 0px 0px 1px #EBEFF3;
  backdrop-filter: blur(5px);
  border: none;
  border-radius: 0px 0px 12px 12px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: max-content;
  z-index: 10;
  padding: 10px 12px;
  display: flex;
  gap: 4px;
  align-items: center;

}
.fade-enter-active,
.fade-leave-active {
  transition: all 150ms !important;
}

.fade-enter,
.fade-leave-to .fade-leave-active {
  opacity: 0;
}
</style>
